.DateChangeDayContainer
    width: 29px
    height: 29px
    box-sizing: border-box
    display: flex
    align-items: center
    justify-content: center
    cursor: pointer
    stroke: rgb($globalSettingsFontSecondary)
    border-radius: $globalButtonRounding
    transition: background 0.8s
    &:hover
        background: rgb($globalSettingsBackgroundSecondary)
        stroke: rgb($globalSettingsFontPrimary)
    &:focus
        outline: none
        background: rgb($globalSettingsBackgroundSecondary)
        stroke: rgb($globalSettingsFontPrimary)

.DateButtonDisabled
    stroke: rgb($globalSettingsFontTertiary)
    cursor: default
    &:hover,  &:focus
        outline: none
        background: rgb($globalSettingsFontTertiary)
